import { componentsEs } from '@project/components';
export default {
  ...componentsEs,
  "currencyCode": "USD",

  /************************************************************
   * ID360 Components
   * -----------------------------------
   * First section of id corresponds to component using the
   * translation
   ************************************************************/
  "AssetModal.deleteMessage": "¿Está seguro de que desea eliminar este activo?",
  "AssetModal.warning": "Advertencia: hay cambios sin guardar.",

  "AssetSection.noAssets": "Sin Activos",
  "AssetSection.addAsset": "+ Agregar {asset}",

  "BasicInfoForm.uploadFloorplanPhotos": "Cargar fotos de planos de planta adicionales",
  "BasicInfoForm.uploadAdditionalPhotos": "Cargar imágenes adicionales",
  "BasicInfoForm.addressLabel": "Ciudad/Estado/Código Postal",
  "BasicInfoForm.address": "{city}, {state} {postal}",
  "BasicInfoForm.sqftMismatch": "Advertencia: Discrepancia superior al 2% entre la medida de pies cuadrados reales y la medida proporcionada por el cliente",
  "BasicInfoForm.defaultPdfStyle.label": "Plantilla de PDF de ID360",
  "BasicInfoForm.defaultPdfStyle.placeholder": "Estilo predeterminado",
  "BasicInfoForm.upload.featured": "Imagen de la Fachada",
  "BasicInfoForm.upload.additionalImages": "Imágenes para QA",
  "BasicInfoForm.upload.floorplans": "Plano de Planta Destacado",
  "BasicInfoForm.upload.additionalFloorplans": "Imágenes para CAD",
  "BasicInfoForm.upload.profilePdf": "PDF de Perfil",
  "BasicInfoForm.upload.lodPdf": "LOD PDF",
  "BasicInfoForm.upload.autocad": "AUTOCAD",
  "BasicInfoForm.uploadFile.error": "Hubo un error al subir uno o más archivos. Recargue la página e intente nuevamente.",
  "BasicInfoForm.deleteFile.error": "Hubo un error al eliminar uno o más archivos. Recargue la página e intente nuevamente.",

  //ChangeFloorName Component
  "ChangeFloorName.title": "Cambiar Nombre de la Planta",

  //CompanyGeneralTab Component
  "CompanyGeneralTab.contactRepresentativeLabel": "Activar botón de Representante para Contacto",
  "CompanyGeneralTab.showCompanyLogoLabel": "Mostrar el Logotipo de la Empresa en el Perfil",
  "CompanyGeneralTab.showCompanyLogoPdfLabel": "Mostrar el Logotipo de la Empresa en Archivos PDF",
  "CompanyGeneralTab.disablePublicProfilesLabel": "Desactivar Perfiles Públicos",
  "CompanyGeneralTab.zipAssetImagesLabel": "Crear archivo ZIP con Imágenes de Activos",
  "CompanyGeneralTab.description": "Configure los opciones para esta empresa.",
  "CompanyGeneralTab.saveButton": "Guardar configuración",
  "CompanyGeneralTab.title": "Configuración",
  "CompanyGeneralTab.defaultPdfStyle.label": "Seleccione el estilo predeterminado para los PDFs de ID360",
  "CompanyGeneralTab.defaultPdfStyle.placeholder": "Estilo predeterminado",

  //CompanyIntegrationsTabs Component
  "CompanyIntegrationsTabs.bearerToken": "¿Utiliza Token de tipo 'Bearer'?",
  "CompanyIntegrationsTabs.authRequired": "¿Requiere Autenticación?",
  "CompanyIntegrationsTabs.enablePublish": "Activar Notificaciones de Publicación",
  "CompanyIntegrationsTabs.title": "Notificaciones de Publicación",
  "CompanyIntegrationsTabs.saveButton": "Guardar Configuración de Integración",
  "CompanyIntegrationsTabs.description": "Configure las opciones de integración para esta empresa.",
  "CompanyIntegrationsTabs.authUsername": "Nombre de Usuario para Autenticación",
  "CompanyIntegrationsTabs.authPassword": "Contraseña para Autenticación",
  "CompanyIntegrationsTabs.authEndpoint": "URL para Autenticación",
  "CompanyIntegrationsTabs.authTokenKey": "Token para Autenticación",
  "CompanyIntegrationsTabs.authHeaderKey": "Encabezado HTTP de Autenticación",
  "CompanyIntegrationsTabs.endpoint": "URL",
  "CompanyIntegrationsTabs.headers": "Encabezado HTTP",
  "CompanyIntegrationsTabs.payload": "Cuerpo del mensaje",
  "CompanyIntegrationsTabs.authClientID": "ID de Cliente para Autenticación (Client ID)",
  "CompanyIntegrationsTabs.authClientSecret": "Secreto de Cliente para Autenticación (Client Secret)",
  "CompanyIntegrationsTabs.authScope": "Alcance para Autenticación (Scope)",
  "CompanyIntegrationsTabs.payloadFormat.label": "Formato de mensaje",
  "CompanyIntegrationsTabs.payloadFormat.placeholder": "Seleccione formato",
  "CompanyIntegrationsTabs.authType.label": "Tipo de autenticación",
  "CompanyIntegrationsTabs.authType.placeholder": "Seleccione tipo",

  //CompanySettings Component
  "CompanySettings.pageTitle": "Configuración - Admin - ID360",
  "CompanySettings.title": "Configuración de la Empresa",
  "CompanySettings.saveSuccessful": "La configuración de la empresa se guardó correctamente",

  //CompanySettingsTabs Component
  "CompanySettingsTabs.title": "Configuración General",
  "CompanySettingsTabs.fieldSettings.tabTitle": "Configuración de Campo",
  "CompanySettingsTabs.fieldSettings.description": "Desactive los campos que no deberían aparecer para esta empresa",
  "CompanySettingsTabs.fieldSettings.saveButton": "Guardar Configuración de Campo",
  "CompanySettingsTabs.fieldSettings.basicInfoTitle": "Información Básica",
  "CompanySettingsTabs.integrations.tabTitle": "Integraciones",
  "CompanySettingsTabs.visible": "Públicamente Visible",
  "CompanySettingsTabs.required": "Requerido",
  "CompanySettingsTabs.softRequired": "Recomendable completar",
  "CompanySettingsTabs.enabled": "Activado",
  "CompanySettingsTabs.showAssets": "Mostrar Activos de {type}",

  //CreateNewProfile Component
  "CreateNewProfile.title": "Crear nuevo perfil",
  "CreateNewProfile.subtitle": "Crear perfil",
  "CreateNewProfile.addressNotFound": "Dirección no encontrada. Por favor corrija la información en el administrador.",
  "CreateNewProfile.createProfile.button": "Crear perfil",
  "CreateNewProfile.editProfile": "Ediar perfil",
  "CreateNewProfile.hasProfile": "Tiene perfil de ID360",
  "CreateNewProfile.idpRecord.details": "Esto puede encontrarse en la pestaña de 'Administración' en Microsoft CRM en el perfil 360.",
  "CreateNewProfile.idpRecord.required": "Por favor ingrese un valor válido para el ID de registro ID360.",

  //Layout Component
  "Layout.createNewProfile": "Crear Nuevo Perfil",
  "Layout.recent": "Reciente",
  "Layout.companySettings": "Configuración de la Empresa",

  // SurveyableField Component
  "SurveyableField.notSurveyed": "No encuestado",
  "SurveyableField.notSurveyedReason": "Razón",
  "SurveyableField.notSurveyedReason.placeholder": "Seleccione el motivo",
  "SurveyableField.notSurveyedReason.other": "Otro",
  "SurveyableField.notSurveyedReason.other.required": "Por favor, especifique una razón",
  "SurveyableField.notSurveyedOption.construction": "Construcción en el lugar sin acceso",
  "SurveyableField.notSurveyedOption.notProvided": "RSF no indicados en el plano",
  "SurveyableField.notSurveyedOption.permanentCeiling": "Techo de placas de yeso en el espacio",
  "SurveyableField.notSurveyedOption.insulation": "Aislamiento pesado en el techo",
  "SurveyableField.notSurveyedOption.equipmentIssues": "Problemas con el equipo",
  "SurveyableField.notSurveyedOption.noAccess": "El muro es inaccesible",
  "SurveyableField.notSurveyedOption.notPresent": "Pared no presente en el espacio",
  "SurveyableField.notSurveyedOption.notPartOfScope": "No Parte del Scope",
  "SurveyableField.notSurveyedOption.safety": "Cuestiones de seguridad - ver notas",
  "SurveyableField.notSurveyedOption.weather": "Mal tiempo en el momento de la encuesta",
  "SurveyableField.notSurveyedOption.tenantDenied": "Inquilino con acceso denegado",
  "SurveyableField.notSurveyedOption.lockboxIssues": "bloqueado sin acceso",
  "SurveyableField.notSurveyedOption.physicallyInaccessibleObstructions": "Físicamente inaccesible debido a obstáculos",
  "SurveyableField.notSurveyedOption.ceilingNotPresent": "Techo no presente en el espacio",
  "SurveyableField.notSurveyedOption.joistNotPresent": "Viga no presente en el espacio",
  "SurveyableField.notSurveyedOption.deckNotPresent": "Cubierta no presente en el espacio",
  "SurveyableField.notSurveyedOption.girderNotPresent": "Viga no presente en el espacio",
  "SurveyableField.notSurveyedOption.columnNotPresent": "Columnas no presentes en el espacio",
  "SurveyableField.notSurveyedOption.speedBayNotPresent": "Speed Bay no está presente en el espacio",
  "SurveyableField.notSurveyedOption.truckApronNotPresent": "Delantal de camión no presente para el espacio",
  "SurveyableField.notSurveyedOption.truckCourtNotPresent": "Tribunal de camiones no presente para el espacio",
  "SurveyableField.notSurveyedOption.lockboxNotPresent": "Caja de seguridad no presente",
  "SurveyableField.notSurveyedOption.assetNotPresent": "Activos no está presente en el espacio",
  "SurveyableField.notSurveyedOption.lockboxJammed": "Caja de seguridad atascada",
  "SurveyableField.notSurveyedOption.lockboxWrongKey": "La caja fuerte tiene la llave equivocada",
  "SurveyableField.notSurveyedOption.lockboxNoKey": "La caja fuerte no tiene llave",
  "SurveyableField.notSurveyedOption.emergencyReasons": "Motivos de emergencia",
  "SurveyableField.notSurveyedOption.revisitRequired": "Se requiere revisión",

  //ProfileAssetSection Component
  "ProfileAssetSection.noData": "Datos no disponibles.",

  //ProfileFloors Component
  "ProfileFloors.addNewLevel.details": "Esto agregará una nuevo planta al perfil de espacio actual.",
  "ProfileFloors.addNewLevel.title": "Agregar Nueva Planta",
  "ProfileFloors.addNewLevel.confirm": "Agregar Planta",
  "ProfileFloors.addNewLevel.error": "No se puede agregar un nuevo nivel cuando hay errores en el nivel actual.",
  "ProfileFloors.removeLevel.details": "Confirme que desea eliminar {level}. Esto no se puede deshacer.",
  "ProfileFloors.removeLevel.title": "Eliminar Planta",
  "ProfileFloors.removeLevel.confirm": "Eliminar Planta",

  //ProfileImageUpload Component
  "ProfileImageUpload.upload": "Subir {item}",
  "ProfileImageUpload.photos": "Fotos",
  "ProfileImageUpload.floorplans": "Planos de Planta",

  //ProfilePublishButton Component
  "ProfilePublishButton.publish.dropdownTitle": "Publicar",
  "ProfilePublishButton.publish": "Publicar",
  "ProfilePublishButton.publishPreview": "Vista Previa",
  "ProfilePublishButton.publishStatus": "Estado",
  "ProfilePublishButton.publishStatus.modalTitle": "Estado del perfil del espacio",
  "ProfilePublishButton.publish.modalTitle": "Publicar Perfil de Espacio",
  "ProfilePublishButton.unpublish": "Anular la Publicación del Perfil",
  "ProfilePublishButton.tooltip": "Se requiere acceso de administrador para anular la publicación del perfil",
  "ProfilePublishButton.unpublish.confirmLabel": "Anular la Publicación del Perfil",
  "ProfilePublishButton.unpublish.confirmModal": "El perfil del espacio quedará inactivo y ya no será visible para el público.",
  "ProfilePublishButton.publishModal.confirmMessage": "El perfil del espacio será visible públicamente.",
  "ProfilePublishButton.softRequired": "Aún no ha completado todos los campos requeridos para este proyecto. ¿Desea continuar?",
  "ProfilePublishButton.previewModal.confirmMessage": "El perfil del espacio actualmente no contiene errores y está listo para publicarse.",
  "ProfilePublishButton.previewModal.errorsFound": "El perfil de espacio actualmente contiene errores en:",

  //PropertySelect Component
  "PropertySelect.selectProperty": "Seleccionar Propiedad",

  //ProfileShare Component
  "ProfileShare.share": "Compartir",
  "ProfileShare.shareProfile": "Compartir este Perfil",
  "ProfileShare.body": "Por favor, revise este perfil de espacio de ID360:%0D%0A{url}",
  "ProfileShare.subject": "{property} - Unidad {address2}",

  //ProfileStatus Component
  "ProfileStatus.status": "Estado",
  "ProfileStatus.historyMessage": "{altered} por {user} el {date} a las {time}",
  "ProfileStatus.preview": "Vista previa disponible para otros usuarios de ID360 en",
  "ProfileStatus.availablAt": "Disponible en",
  "ProfileStatus.viewProfilePdf": "Ver PDF del perfil",
  "ProfileStatus.viewAdaPdf": "View PDF de ADA",
  "ProfileStatus.privateLink": "Enlace privado",
  "ProfileStatus.view": "Ver",
  "ProfileStatus.zippedAssetImages": "Imágenes",
  "ProfileStatus.generateZippedAssetImages": "Generar Archivo .zip con Imágenes",
  "ProfileStatus.generateZippImageMessage": "Se está generando el archivo Zip. Actualice la página en unos minutos.",

  //RecentProfiles Component
  "RecentProfiles.pageTitle": "Perfiles Recientes - Admin - ID360",
  "RecentProfiles.title": "Reciente",
  "RecentProfiles.searchFilter": "Filtro de Búsqueda",
  "RecentProfiles.searchNoMatches": "Ningún perfil coincide con la búsqueda.",
  "RecentProfiles.address": "{address1}, Unidad {address2}, {city}",
  "RecentProfiles.publish.label": "Estado: ''",

  //Settings Component
  "Settings.pageTitle": "Configuración - Administrador - ID360",
  "Settings.title": "Configuración",
  "Settings.name": "Nombre",
  "Settings.email": "Correo Electrónico",
  "Settings.password": "Contraseña",
  "Settings.changeName": "Cambiar Nombre",
  "Settings.changeEmail": "Cambiar Correo Electrónico",

  //SpaceProfile Component
  "SpaceProfile.title": "Crear nuevo perfil",
  "SpaceProfile.basicInfo": "Información Básica",
  "SpaceProfile.modal.timeoutModalHeader": "Mensaje de ID360",
  "SpaceProfile.modal.timeoutModalText": "La página ha estado inactiva demasiado tiempo. Por favor recárguela.",
  "SpaceProfile.modal.timeoutmodalReload": "Recargar",
  "SpaceProfile.alerts.noAssetGuid": "Error: Unidad (Activo de tipo 'Espacio') no encontrada. Póngase en contacto con el administrador.",

  //SpaceSelect Component
  "SpaceSelect.placeholder": "Seleccionar Espacio",

  //ViewProfile Component
  "ViewProfile.contact": "Representante de Contacto",
  "ViewProfile.dataPoints": "{dataPoints, plural, =0 {# puntos de datos} one {# punto de datos} other {# puntos de datos}} en este espacio",
  "ViewProfile.address1": "{address}, {city}, {state}, {postal}",
  "ViewProfile.address2": "Unidad {address2}",
  "ViewProfile.width": "ancho",
  "ViewProfile.depth": "profundidad",
  "ViewProfile.pageTitle": "{name} - Unidad {address2} - ID360",
  "ViewProfile.description": "{name} - Unidad {address2} - Perfil de Espacio ID360",
  "ViewProfile.assetManager": "Gestor de Activos",
  "ViewProfile.leasingRepresentative": "Representante de Arrendamiento",
  "ViewProfile.propertyManager": "Administrador de la Propiedad",
  "ViewProfile.billingSpecialist": "Especialista en Facturación",
  "ViewProfile.renewalAgent": "Agente de Renovación",
  "ViewProfile.propertyManagerAssistant": "Asistente de Gerente de Propiedad",
  "ViewProfile.leasingAgent": "Agente de Arrendamiento",
  "ViewProfile.constructionManager": "Gerente de Construcción",

  /************************************************************
   * Asset Schema
   * -----------------------------------
   * Translations for the asset schema file which is used
   * throughtout the application
   ************************************************************/

  //AssetSchema
  "assetSchema.headers.thickness": "Espesor",
  "assetSchema.headers.unit_overview": "Descripción General de la Unidad",
  "assetSchema.headers.flooring": "Piso",
  "assetSchema.headers.ceiling_information": "Información del Techo",
  "assetSchema.headers.outer_unit_corner_to_outer_block_corner": "Esquina Exterior de la Unidad a Esquina Exterior del Bloque",
  "assetSchema.headers.height_from_floor_to_bottom_of_girder_kite": "Altura del suelo a la parte inferior de la viga (Scope Especial)",
  "assetSchema.headers.construction_overview": "Descripción General de la Construcción",
  "assetSchema.headers.property_features": "Caracteristicas de la Propiedad",
  "assetSchema.headers.other": "Otro",
  "assetSchema.headers.integrations": "Integraciones",
  "assetSchema.headers.floorplan": "Plano de Planta",
  "assetSchema.headers.floorplans": "Planos de Planta",
  "assetSchema.headers.space_overview": "Descripción General del Espacio",
  "assetSchema.headers.overview": "Descripción General",
  "assetSchema.headers.interior_dock_leveler_type": "Tipo de plataforma interior",
  "assetSchema.headers.interior_dock_leveler_width": "Anchura de la plataforma interior",
  "assetSchema.headers.interior_dock_leveler_height": "Altura de la rampa interior",
  "assetSchema.headers.dock_leveler_length": "Longitud de la rampa interior",
  "assetSchema.headers.mechanical": "Mecánica",
  "assetSchema.headers.hydraulic": "Hidráulica",
  "assetSchema.headers.storefront_width": "Anchura del escaparate (incluye el grosor medio de las paredes)",
  "assetSchema.headers.storefront_features": "Características del escaparate",
  "assetSchema.headers.damaged_stained_missing_acoustical_tiles": "Número de losetas acústicas dañadas, manchadas o que faltan",
  "assetSchema.headers.ceiling_types": "Seleccione los tipos de techo presentes en el espacio",
  "assetSchema.headers.wall_types": "Seleccione los tipos de pared presentes en el interior del espacio",
  "assetSchema.headers.exterior_door_count": "Recuento de puertas exteriores",
  "assetSchema.headers.exterior_door_dimensions": "Dimensiones de la puerta exterior (3'0”W x 7'0”H)",
  "assetSchema.headers.exterior_door_locations": "Ubicación de las puertas exteriores",
  "assetSchema.headers.light_fixture_count": "Recuento de luminarias",
  "assetSchema.headers.type_of_lighting": "Tipo de iluminación",
  "assetSchema.headers.type_of_fixture": "Tipo de fijación",

  "assetSchema.options.encased": "Encasillado",
  "assetSchema.options.suspended": "Suspendido",
  "assetSchema.options.recessed": "Empotrado",
  "assetSchema.options.flush_mount": "Montaje empotrado",
  "assetSchema.options.track": "Pista",
  "assetSchema.options.sconce": "Sconce",
  "assetSchema.options.strip": "Strip",
  "assetSchema.options.flourescent": "Flourescent",
  "assetSchema.options.led": "LED",
  "assetSchema.options.halogen": "Halógeno",
  "assetSchema.options.metal_hallide": "Hallide metálico",
  "assetSchema.options.hps": "HPS (High Pressure Sodium)",
  "assetSchema.options.incandescent": "Incandescente",
  "assetSchema.options.NA": "NA",
  "assetSchema.glass": "Cristal",
  "assetSchema.stone": "Piedra",
  "assetSchema.concrete_type": "Concreto",
  "assetSchema.vinyl": "Vinilo",
  "assetSchema.pvc": "PVC",
  "assetSchema.tile_type": "Azulejos",
  "assetSchema.brick": "Ladrillo",
  "assetSchema.fiber_reinforced_plastic": "Plástico reforzado con fibra",
  "assetSchema.open_stud": "Espárrago abierto",
  "assetSchema.open_ceiling": "Techo abierto",
  "assetSchema.acoustic_tile": "Azulejos acústicos",
  "assetSchema.drywall": "Tablero de yeso",
  "assetSchema.wood": "Madera",
  "assetSchema.metal": "Metálico",
  "assetSchema.concrete_ceiling_type": "Concreto",
  "assetSchema.stucco": "Estuco",
  "assetSchema.inconclusive": "No concluyente",
  "assetSchema.inaccessible": "Inaccessible",
  "assetSchema.walkway": "Pasarela",
  "assetSchema.trash_cans": "Cubo(s) de basura",
  "assetSchema.ash_trays": "Cenicero(s)",
  "assetSchema.handicap_parking": "Aparcamiento para minusválidos",
  "assetSchema.columns": "Columna(s)",
  "assetSchema.crosswalk": "Paso de peatones",
  "assetSchema.canopy": "Marquesina",
  "assetSchema.trees": "Árbol(es)",
  "assetSchema.bushes": "Arbustos",
  "assetSchema.steps": "Paso(s)",
  "assetSchema.ramps": "Rampa(s)",
  "assetSchema.handicap_signs": "Señal(es) de minusvalía",
  "assetSchema.stop_signs": "Señal(es) de Stop",
  "assetSchema.tenant_signs": "Cartel(es) de inquilino",
  "assetSchema.other_affixed_signage": "Otros carteles fijados",
  "assetSchema.railings": "Barandilla(s)",
  "assetSchema.bollards": "Bolardo(s)",
  "assetSchema.grass": "Hierba",
  "assetSchema.garden": "Jardín",
  "assetSchema.fire_hydrant": "Boca de incendios",
  "assetSchema.planters": "Jardineras",
  "assetSchema.dirt": "Suciedad",
  "assetSchema.other": "Otros",
  "assetSchema.not_available": "N/A",
  "assetSchema.rear": "Trasera",
  "assetSchema.all_sides": "Todos los lados",
  "assetSchema.left_side": "Lado izquierdo",
  "assetSchema.right_side": "Lado derecho",


  "assetSchema.separate_rpm_renders.label": "¿Dividir el mapa del sitio de RPM en varias secciones?",
  "assetSchema.joist_direction.label": "Dirección de la vigueta",
  "assetSchema.joist_direction.placeholder": "Seleccione",
  "assetSchema.joist_direction.front_to_back": "De adelante hacia atrás",
  "assetSchema.joist_direction.left_to_right": "De izquierda a derecha",
  "assetSchema.joist_direction.other": "Otra dirección - Ver plano de planta",
  "assetSchema.virtual_tour_link.label": "Enlace de Visita Virtual",
  "assetSchema.virtual_tour_link.placeholder": "ej: westshore.ispy-360.com",
  "assetSchema.actual_sq_ft.label": "Metros Cuadrados Reales (BOMA)",
  "assetSchema.overall_actual_sq_ft.label": "Metros Cuadrados Reales Totales (Todas las Plantas)",
  "assetSchema.actual_sq_ft.publicLabel": "Pies Cuadrados Reales",
  "assetSchema.overall_actual_sq_ft.publicLabel": "Metros Cuadrados Reales Totales",
  "assetSchema.actual_sq_ft.placeholder": "Pies Cuadrados Medidos",
  "assetSchema.overall_actual_sq_ft.placeholder": "Sólo unidades de varios pisos",
  "assetSchema.client_provided_sq_ft.label": "Pies Cuadrados Proporcionados por el Cliente",
  "assetSchema.client_provided_sq_ft.placeholder": "Pies Cuadrados Proporcionados",
  "assetSchema.has_stepdown_transformer.label": "¿Hay un transformador reductor?",
  "assetSchema.tear_sheet.label": "Tear Sheet",
  "assetSchema.size.label": "ft² no dedicados a almacenamiento",
  "assetSchema.office_area": "% de ft² no dedicados a almacenamiento",
  "assetSchema.mezannine_area": "Área del Entrepiso (ft²)",
  "assetSchema.year_built": "Año de Construcción",
  "assetSchema.site_size.label": "Tamaño del Sitio (Superficie Total)",
  "assetSchema.tax_pin.label": "PIN de Impuestos (Número de ID de la Parcela)",
  "assetSchema.zoning": "Zonificación (Designación)",
  "assetSchema.measured_width_of_space.publicLabel": "Ancho Medido del Espacio",
  "assetSchema.measured_width_of_space.label": "Ancho Medido del Espacio (CAD solamente)",
  "assetSchema.is_drive_thru_connected_to_space.label": "¿Está el drive-thru conectado al espacio?",
  "assetSchema.measured_width_of_space.placeholder": "Frente exterior a fondo exterior",
  "assetSchema.measured_depth_of_space.label": "Profundidad Medida del Espacio",
  "assetSchema.measured_depth_of_space.placeholder": "Frente exterior a fondo exterior",
  "assetSchema.total_depth_of_space.label": "Profundidad del Espacio (Según Magicplan)",
  "assetSchema.total_depth_of_space.publicLabel": "Profundidad Total del Espacio",
  "assetSchema.total_depth_of_space.placeholder": "Frente exterior a fondo exterior",
  "assetSchema.storefront_slope_measurement.label": "Medición de la inclinación del escaparate",
  "assetSchema.storefront_slope_measurement.placeholder": "Anchura total del escaparate",
  "assetSchema.storefront_slope_direction.label": "Dirección de la pendiente del escaparate",
  "assetSchema.storefront_slope_direction.placeholder": "Derecha",
  "assetSchema.riser_room_scanned_captured.label": "Sala Riser Escaneada/Capturada",
  "assetSchema.changes_in_demising_wall_thickness.label": "¿Hay cambios en el espesor de la pared medianera?",
  "assetSchema.which_demising_wall_changes.label": "¿Qué muro(s) de demolición presenta(n) cambios de grosor?",
  "assetSchema.which_demising_wall_changes.placeholder": "Trasera, Derecha",
  "assetSchema.difference_demising_wall_thickness.label": "¿Cuál es la diferencia entre los espesores de las paredes desmontables? (en pulgadas)",
  "assetSchema.difference_demising_wall_thickness.placeholder": "3\"",
  "assetSchema.hazardous_materials.label": "¿Hay materiales peligrosos presentes?",
  "assetSchema.loading_dock.label": "¿Hay un muelle de carga en las instalaciones?",
  "assetSchema.left": "Izquierdo",
  "assetSchema.right": "Derecho",
  "assetSchema.left_front": "Izquierda Delantera",
  "assetSchema.left_rear": "Izquierda Trasera",
  "assetSchema.right_rear": "Derecha Trasera",
  "assetSchema.right_front": "Derecha Delantera",
  "assetSchema.middle": "Medio",
  "assetSchema.thickness.front_wall": "Pared Frontal",
  "assetSchema.thickness.rear_wall": "Pared Posterior",
  "assetSchema.thickness.left_wall": "Pared Izquierda",
  "assetSchema.thickness.right_wall": "Pared Derecha",
  "assetSchema.thickness.other": "Otro",
  "assetSchema.sales_area": "Area de Ventas",
  "assetSchema.stock_room": "Sala de Stock",
  "assetSchema.exterior_doors": "Puertas Exteriores",
  "assetSchema.unit_overview.other": "Otra",
  "assetSchema.concrete": "ft² de Hormigón",
  "assetSchema.tile": "ft² de Loseta",
  "assetSchema.flooring.other": "ft² de Otros",
  "assetSchema.carpet": "ft² de Alfombrado",
  "assetSchema.flooring.total.label": "ft² de Total la Unidad sin Paredes",
  "assetSchema.flooring.total.publicLabel": "ft² Totales",
  "assetSchema.flooring.unit.label": "ft² de Totales la Unidad con Paredes",
  "assetSchema.flooring.unit.publicLabel": "ft² de la Unidad",
  "assetSchema.flooring.type_of_other.label": "Otro Tipo de Piso",
  "assetSchema.flooring.type_of_other.placeholder": "Linóleo",
  "assetSchema.front": "Delantero",
  "assetSchema.back": "Trasero",
  "assetSchema.center": "Centro",
  "assetSchema.height_from_floor_to_bottom_of_girder": "Altura desde el piso hasta la parte inferior de la viga",
  "assetSchema.height_from_floor_to_bottom_of_girder_not_part_of_scope": "No Parte del Scope",
  "assetSchema.clear_ceiling_height": "Altura del Techo Despejado",
  "assetSchema.number_of_acoustical_tiles": "Número de Baldosas Acústicas",
  "assetSchema.structure.label": "Estructura",
  "assetSchema.structure.placeholder": "Hormigón Prefabricado Inclinable",
  "assetSchema.roof.label": "Tipo de Techo",
  "assetSchema.roof.placeholder": "Membrana EPDM de Una Capa con Lastre de Grava",
  "assetSchema.roof_warranty_expiration.label": "Vencimiento de la Garantía del Techo",
  "assetSchema.sprinkler_head_type.label": "Tipo de cabezal de rociador",
  "assetSchema.sprinkler_system.label": "Sistema de Rociadores / ESFR",
  "assetSchema.warehouse_sprinkler_head_type.label": "Tipo de cabeza de rociador no dedicados a almacenamiento",
  "assetSchema.office_sprinkler_head_type.label": "Tipo de cabeza de rociador  no dedicados a almacenamiento",
  "assetSchema.office_lighting_type.label": "Tipo de iluminación de oficina (tipo de bombilla)",
  "assetSchema.sprinkler_system.placeholder": "Húmedo / No",
  "assetSchema.warehouse_lighting_type.label": "Tipo de Iluminación de Almacén (Tipo de Bombilla)",
  "assetSchema.warehouse_lighting_type.placeholder": "T5",
  "assetSchema.exterior_wall_photograph.label": "¿Tiene la parte trasera del espacio una pared exterior que fotografiar?",
  "assetSchema.storefront_scan_width.label": "¿La foto y el escaneado del escaparate muestran toda la anchura del espacio?",
  "assetSchema.roof_capture_hvac.label": "¿Tiene el espacio un tejado directamente y está completo el plano del tejado?",
  "assetSchema.roof_plan_complete.label": "¿Tiene el espacio un tejado directamente encima y está completo el plano del tejado?",
  "assetSchema.projector_photograph.label": "¿Hay algún proyector en el espacio fotografiado?",
  "assetSchema.window_pane_type.label": "¿Las ventanas son de vidrio alveolar o están aisladas?",
  "assetSchema.window_pane_type.placeholder": "Doble acristalamiento, Acristalamiento simple",
  "assetSchema.single_pane": "Acristalamiento simple",
  "assetSchema.double_pane": "Doble acristalamiento",
  "assetSchema.triple_pane": "Triple acristalamiento",
  "assetSchema.access_interior_area.label": "¿Se accede al espacio desde una zona interior compartida?",
  "assetSchema.floor_drain_count.label": "Recuento de desagües del suelo",
  "assetSchema.floor_drain_location.label": "Ubicación del desagüe en el suelo",
  "assetSchema.phone_board_count.label": "Recuento de teléfonos",
  "assetSchema.thermostat_count.label": "Recuento de termostatos",
  "assetSchema.cleanout_count.label": "Recuento de limpieza",
  "assetSchema.cleanout_location.label": "Ubicación de la limpieza",
  "assetSchema.pad_mounted_transformer_count.label": "Recuento de transformadores montados en panel",
  "assetSchema.pad_mounted_transformer_location.label": "Ubicación del transformador en pedestal",
  "assetSchema.exterior_transformer.label": "¿Hay un transformador exterior?",
  "assetSchema.meter_room_space.label": "¿Hay contadores en el espacio situado en un cuarto de contadores?",
  "assetSchema.exterior_access_rooms.label": "¿Hay habitaciones a las que se acceda desde el exterior que estén dentro de la huella del espacio?",
  "assetSchema.exterior_partition_extrusion.label": "¿Existen añadidos a las paredes exteriores, como tabiques o extrusiones de pared, que añadan grosor a las paredes exteriores?",
  "assetSchema.hydraulic_sprinkler.label": "¿Se ha fotografiado la placa de un sistema de rociadores hidráulicos?",
  "assetSchema.clear_height": "Altura Libre (Piso a Viga)",
  "assetSchema.building_dimensions": "Dimensiones del Edificio",
  "assetSchema.space_dimensions_width": "Ancho del Espacio",
  "assetSchema.space_dimensions_length": "Longitud del Espacio",
  "assetSchema.space_dimensions": "Dimensiones del espacio",
  "assetSchema.column_bay_spacing": "Espacio entre columnas (Ancho)",
  "assetSchema.column_bay_spacing_depth": "Espacio entre columnas (Profundidad)",
  "assetSchema.speed_bays": "Bahías de Velocidad (Profundidad)",
  "assetSchema.truck_court_depth": "Profundidad de la Zona de Camiones (Longitud)",
  "assetSchema.truck_apron": "Pista de camión",
  "assetSchema.loading.label": "Cargando (Tipo)",
  "assetSchema.loading.placeholder": "Carga Delantera / Carga Trasera / Crossdock",
  "assetSchema.floor_load": "Carga del Piso (Libras por ft²)",
  "assetSchema.num_of_trailer_parking_spots": "# de Lugares de Estacionamiento de Remolques",
  "assetSchema.dock_doors": "Puertas de Muelle",
  "assetSchema.drive_in_doors": "Puertas de Entrada",
  "assetSchema.railway_dock_doors": "Recuento de puertas de muelles ferroviarios",
  "assetSchema.car_parking": "Aparcamiento de Coches",
  "assetSchema.hvac": "HVAC (# de unidades HVAC)",
  "assetSchema.utility_submetered": "Utilidad Submedida (Sí / No)",
  "assetSchema.power.label": "Información de Energía",
  "assetSchema.power.placeholder": "400-Amperios, 277/480-Voltios, Trifásico, 4-Cables",
  "assetSchema.electric_meter_distance": "¿Distancia del medidor eléctrico en pies completos?",
  "assetSchema.gas_meter_distance": "¿Distancia del medidor de gas en pies completos?",
  "assetSchema.water_meter_distance": "¿Distancia del medidor de agua en pies completos?",
  "assetSchema.transformer_distance": "Transformador montado en pedestal ¿Distancia de la unidad en pies completos?",
  "assetSchema.sewer_cleanout_distance": "¿Distancia de limpieza de alcantarillado en pies completos?",
  "assetSchema.utility_room_distance": "¿Distancia del cuarto de servicio en pies completos?",
  "assetSchema.DMARC_distance": "¿Distancia DMARC en pies completos?",
  "assetSchema.phone_board_location": "Ubicación de la Placa del Teléfono",
  "assetSchema.mop_sink_location": "Ubicación de Fregadero",
  "assetSchema.mop_sink_count": "Recuento de Fregonas",
  "assetSchema.sanitary_sewer_location": "Ubicación de la Alcantarilla Sanitaria",
  "assetSchema.sanitary_sewer_count": "Recuento de alcantarillado sanitario",
  "assetSchema.thermostat_location.label": "Ubicación del Termostato",
  "assetSchema.cooler_manufacturer": "Fabricante del Enfriador",
  "assetSchema.are_demising_walls_full_height": "¿Los muros de separación llegan hasta la cubierta?",
  "assetSchema.are_interior_walls_full_height": "¿Las paredes interiores llegan hasta la cubierta?",
  "assetSchema.lockbox_used_to_access_the_space": "¿Caja fuerte para acceder al espacio?",
  "assetSchema.exterior_ladder_used_to_access_the_roof": "¿Escalera exterior para acceder al tejado?",
  "assetSchema.roof_too_unsafe_to_access": "¿Demasiado inseguro para acceder al tejado?",
  "assetSchema.roof_hatch_used_to_access_the_roof": "¿Se utiliza una trampilla para acceder al tejado?",
  "assetSchema.misc_notes.label": "Notas Misceláneas",
  "assetSchema.misc_notes.placeholder": "Notas",
  "assetSchema.integrations": "ID de Integración de la Propiedad",
  "assetSchema.integrations.idp_record_id": "ID de Registro de ID360",
  "assetSchema.flooring_square_footage": "Pisos en ft²",
  "assetSchema.height_from_floor_to_ceiling": "Altura del Suelo al Techo",
  "assetSchema.height_from_floor_to_bottom_of_deck": "Altura Desde el Piso Hasta la Parte Inferior de la Plataforma",
  "assetSchema.height_from_floor_to_bottom_of_joist": "Altura Desde el Piso Hasta la Parte Inferior de la Viga",
  "assetSchema.clear_height_floor_to_deck": "Altura libre (del piso a la plataforma)",
  "assetSchema.clear_height_floor_to_lowest_obstruction": "Altura libre (desde el piso hasta la obstruccion inferior)",
  "assetSchema.clear_height_floor_front_column": "Altura libre (en la columna frontal)",
  "assetSchema.clear_height_floor_mid_column": "Altura libre (a mitad de columna)",
  "assetSchema.clear_height_floor_rear_column": "Altura libre (en columna trasera)",
  "assetSchema.section.mechanical": "Climatización",
  "assetSchema.section.electrical": "Electricidad",
  "assetSchema.section.plumbing": "Agua",
  "assetSchema.section.waste": "Contenedor de Basura",
  "assetSchema.section.fire": "Fuego",
  "assetSchema.section.gas": "Gas",
  "assetSchema.section.room": "ADA",
  "assetSchema.section.window": "Planos de Ventana",
  "assetSchema.section.reflective": "Planos de Techo Reflejados",
  "assetSchema.section.storefronts": "Escaparates",

  /************************************************************
   * General Use
   * -----------------------------------
   * General use translations that are used throughout the
   * application in multiple components
   ************************************************************/

  //Error Message
  "error.general": "Ocurrió un error",
  "error.server": "El servidor no responde",
  "error.spaceProfile.create": "Hubo un error al crear el perfil del espacio.",
  "error.deleteFile": "Hubo un error al eliminar el archivo.",
  "error.iconNotFound": "Ícono de carga {icon} no encontrado. Usando el ícono predeterminado.",
  "error": "Error",
  "error.required": "{field} es obligatorio",
  "error.valid": "Ingrese un valor válido para {field}",
  "error.addNewLevel": "Hubo un error al agregar una nueva planta.",
  "error.deleteNewLevel": "Hubo un error al eliminar la planta.",

  //Files
  "file.floorplan": "Planta Baja",
  "file.featured": "Imagen de Tienda",
  "file.autocad": "AUTOCAD",
  "file.pdf": "LOD PDF",
  "file.profile_pdf": "PDF de Perfil",
  "file.internal_files": "Archivos Internos",

  //Floor Labels
  "floorLabels.basement1": "Subsuelo 1",
  "floorLabels.basement2": "Subsuelo 2",
  "floorLabels.groundFloor": "Planta Baja",
  "floorLabels.mainFloor": "Piso Principal",
  "floorLabels.mezzanine": "Entrepiso",
  "floorLabels.level": "Piso {level}",
  "floorLabels.selector": "Piso Selector",

  //Platform Related Language
  "platform.roles.admin": "Admin",

  // Business or general use terms that are often repeated as content for button
  "term.company": "Compañía",
  "term.property": "Propiedad",
  "term.unavailable": "No disponible",
  "term.available": "Disponible",
  "term.visible": "Visible",
  "term.required": "Requerido",
  "term.enabled": "Activado",
  "term.unit": "Unidad",
  "term.unit_no": "Unidad #",
  "term.address": "Dirección",
  "term.unknown": "Desconocido",
  "term.search": "Búsqueda",
  "term.assetType": "Tipo de Activo",
  "term.floorplan": "Planta baja",
  "term.asset": "Activo",
  "term.published": "publicado",
  "term.unpublished": "sin publicar",
  "term.draft": "borrador",
  "term.other": "Otro",

  //UI elements (common UI buttons, interactions)
  "ui.saving": "Guardando",
  "ui.loading": "Cargando",
  "ui.addressDisplay": "{address}, {city}, {stateOrRegion} {postal}",
  "ui.logout": "Cerrar Sesión",
  "ui.uploadItem": "Subir {item}",
  "ui.uploading": "Subiendo",
  "ui.default": "Predeterminado",
  "ui.theme": "Tema",
  "ui.themeTemplate": "Tema {name}",
  "ui.goBack": "Regresar",
  "ui.close": "Cerrar",
  "ui.delete": "Eliminar",
  "ui.cancel": "Cancelar",
  "ui.deleting": "Eliminando",
  "ui.save": "Guardar",
  "ui.details": "Detalles",
  "ui.uploads": "Subidas",
  "ui.photos": "Fotos",
  "ui.images": "Imágenes",
  "ui.reference": "Referencia",
  "ui.unitNo": "{unit} #",
  "ui.select": "Seleccione",
  "ui.ok": "OK",
  "ui.yes": "Sí",
  "ui.no": "No",
  "ui.areYouSure": "¿Está seguro?",
  "ui.name": "Nombre",
  "ui.size": "Tamaño",
  "ui.uploadDate": "Fecha de subida",
  "ui.uploadedBy": "Subido por",
  "ui.uploadAFile": "Subir un archivo",
  "ui.fileManager": "Gestor de Archivos",

  // Measurement Units
  "unit.squareFootage": "ft²",
  "unit.squareMeters": "m²",
  "unit.feet": "pies",
  "unit.inches": "pulgadas",

  /************************************************************
   * Monorepo Components
   * -----------------------------------
   * Translations need to be passed in props as these components
   * don't have access to the intl provider
   ************************************************************/

  //AdminInput Component
  "AdminInput.validationMessage": "Ingrese un valor válido para ''{label}''",

  //AdminModal Component
  "AdminModal.deleteMessage": "¿Está seguro de la acción a realizar?",
  "AdminModal.yesDelete": "Sí, eliminar",

  //ColorPicker Component
  "ColorPicker.chooseHex": "Seleccione HEX#",
  "ColorPicker.hex": "HEX#",
  "ColorPicker.opacity": "Opacidad",

  "CompanySelect.placeholder": "Seleccione...",
  "CompanySelect.loadingMessage": "Cargando...",
  "CompanySelect.noOptions": "Sin Opciones",

  //Contact Component
  "Contact.phone": "T",
  "Contact.email": "C",
  "Contact.propertyContact": "Contacto de la Propiedad",
  "Contact.assetManager": "Gestor de Activos",
  "Contact.leasingRepresentative": "Representante de Arrendamiento",
  "Contact.propertyManager": "Administrador de la Propiedad",
  "Contact.billingSpecialist": "Especialista en Facturación",
  "Contact.renewalAgent": "Agente de Renovación",
  "Contact.propertyManagerAssistant": "Asistente de Gerente de Propiedad",
  "Contact.leasingAgent": "Agente de Arrendamiento",
  "Contact.constructionManager": "Gerente de Construcción",

  //MapView Component
  "MapView.noResults": "No se han encontrado resultados"
}
